//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sysRoles, sysRoles_del, sysRoleEntRelas_relas } from '@/apis/system'

export default {
    data() {
        return {
            form: {
                roleName: '',
            },
            isLoading: false,
            //table data
            data: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns.push({ title: '角色名稱', dataIndex: 'roleName', key: 'roleName' });
        this.columns.push({ title: 'sysType', dataIndex: 'sysType', key: 'sysType' });
        this.columns.push({ title: '修改時間', dataIndex: 'updatedAt', key: 'updatedAt' });
        this.columns.push({ title: '操作', key: 'operation', width: 330, scopedSlots: { customRender: 'action' }, });
    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageLoad();
        });
    },
    methods: {
        async onPageLoad(isPostBack) {
            if (this.isLoading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.isLoading = true;
                const res = await sysRoles({
                    ...this.form,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                });
                this.data = res.data.records;
                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.isLoading = false;
            }
        },
        /* 頁面事件鉤子 */
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad(true);
        },
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        async handleOnReset(roleId) {
            try {
                const res = await sysRoleEntRelas_relas(roleId);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        //刪除行
        async handleRowDelete(item) {
            try {
                const res = await sysRoles_del(item.roleId);
                if (res.code == 0) {
                    this.onPageLoad();
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        handleToInstall() {
            this.$router.push(`/security/role/form`);
        },
        handleToEdit(id) {
            this.$router.push(`/security/role/form/${id}`);
        }
    }
}
